<template>
    <v-container fluid px-3 pt-3>
        <v-row row wrap>
            <v-col cols="12">
                <h3>User Setup</h3>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="6">
                <v-text-field label="First Name" v-model="firstName" ></v-text-field>
            </v-col>
            <v-col cols="6">
                <v-text-field label="Last Name" v-model="lastName"></v-text-field>
            </v-col>
        </v-row>
        <v-form v-model="agencyForm" v-show="requiresAgency">
            <v-row>
                <v-col cols="3">
                    Select your affiliated agency:
                </v-col>
                <v-col cols="5">
                    <v-select
                        :clearable="true"
                        v-model="selectedAgency"
                        item-text="description"
                        item-value="id"
                        :items="agencies"
                        required :rules="requiredRule">
                    </v-select>
                </v-col>
                <v-col>
                    <v-text-field label="Agency Division" v-model="agencyDto.agencyDivision" required :rules="requiredRule"></v-text-field>
                </v-col>
            </v-row>
            <v-row v-if="selectedAgency == 21 || selectedAgency == 47 || selectedAgency == 26">
                <v-col cols="6">
                    <v-text-field label="Manager Name" v-model="agencyDto.managerName" required :rules="requiredRule"></v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-text-field label="Manager Email" v-model="agencyDto.managerEmail" required :rules="requiredRule"></v-text-field>
                </v-col>
                <v-col cols="12">
                    <v-textarea label="Reason For Request(s)" v-model="agencyDto.accessRequestReason" required :rules="requiredRule"></v-textarea>
                </v-col>
                <v-col cols="12">
                    <h3>Verification Access Requests</h3>
                </v-col>
                <v-col cols="4" align="center">
                    <v-checkbox label="Birth" v-model="requestBirth" :disabled="birthDisabled"></v-checkbox>
                </v-col>
                <v-col cols="4" align="center">
                    <v-checkbox label="Paternity Affidavit" v-model="requestPatAff" :disabled="affidavitDisabled"></v-checkbox>
                </v-col>
                <v-col cols="4" align="center">
                    <v-checkbox label="Death" v-model="requestDeath" :disabled="deathDisabled"></v-checkbox>
                </v-col>
                <v-col cols="4" align="center">
                    <v-checkbox label="Death Insurance" v-model="requestDeathInsurance" :disabled="insuranceDisabled"></v-checkbox>
                </v-col>
                <v-col cols="4" align="center">
                    <v-checkbox label="Marriage" v-model="requestMarriage" :disabled="marriageDisabled"></v-checkbox>
                </v-col>
                <v-col cols="4" align="center">
                    <v-checkbox label="Divorce" v-model="requestDivorce" :disabled="divorceDisabled"></v-checkbox>
                </v-col>
            </v-row>
        </v-form>
        <v-row>
            <v-col cols="12">
                <v-btn @click="saveUser()">Save</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import lookupService from '@/services/lookupService'
import userService from '@/services/userService'
import accessRequestService from '@/services/accessRequestService'
import store from '@/store/store'

export default {
    data: () => {
        return {
            agencyForm: null,
            agencies: [],
            requiresAgency: false,
            selectedAgency: null,
            firstName: null,
            lastName: null,
            requestBirth: false,
            requestPatAff: false,
            requestDeath: false,
            requestDeathInsurance: false,
            requestMarriage: false,
            requestDivorce: false,
            portalUser: null,
            agencyDto: {
                agencyId: null,
                managerName: null,
                managerEmail: null,
                accessRequestReason: null,
                agencyDivision: null
            },
            requiredRule: [v => !!v || 'Required'],
            birthDisabled: false,
            deathDisabled: false,
            marriageDisabled: false,
            divorceDisabled: false,
            insuranceDisabled: false,
            affidavitDisabled: false
        }
    },
    mounted () {
        lookupService.GetAgencies(this.$http).then(response => {
            this.agencies = response.data
        })

        userService.getCurrentPortalUser(this.$http).then(response => {
            this.portalUser = response.data
            this.firstName = this.portalUser.firstName
            this.lastName = this.portalUser.lastName
            this.requiresAgency = this.portalUser.email.toLowerCase().includes('@wyo.gov')
        })

        userService.getCurrentPortalUserAgency(this.$http).then(response => {
            if (response.data) {
                if (response.data.agencyId) {
                    this.selectedAgency = response.data.agencyId
                }

                this.agencyDto = response.data
            }
        })

        accessRequestService.getRequestsForCurrentUser(this.$http).then(response => {
            if (response.data) {
                this.birthDisabled = response.data.filter(f => f.roleRequest === 3).length > 0
                this.deathDisabled = response.data.filter(f => f.roleRequest === 4).length > 0
                this.divorceDisabled = response.data.filter(f => f.roleRequest === 6).length > 0
                this.marriageDisabled = response.data.filter(f => f.roleRequest === 5).length > 0
                this.affidavitDisabled = response.data.filter(f => f.roleRequest === 7).length > 0
                this.insuranceDisabled = response.data.filter(f => f.roleRequest === 8).length > 0
            }
        })
    },
    methods: {
        saveUser () {
            if (this.requiresAgency && this.agencyForm) {
                this.agencyDto.agencyId = this.selectedAgency
                userService.addAgencyToCurrentUser(this.$http, this.agencyDto)
                if (this.requestBirth && !this.birthDisabled) {
                    accessRequestService.insertRequest(this.$http, 3)
                }
                if (this.requestPatAff && !this.affidavitDisabled) {
                    accessRequestService.insertRequest(this.$http, 7)
                }
                if (this.requestDeath && !this.deathDisabled) {
                    accessRequestService.insertRequest(this.$http, 4)
                }
                if (this.requestMarriage && !this.marriageDisabled) {
                    accessRequestService.insertRequest(this.$http, 5)
                }
                if (this.requestDivorce && !this.divorceDisabled) {
                    accessRequestService.insertRequest(this.$http, 6)
                }
                if (this.requestDeathInsurance && !this.insuranceDisabled) {
                    accessRequestService.insertRequest(this.$http, 8)
                }
            }
            if (this.firstName !== null && this.lastName !== null) {
                this.portalUser.firstName = this.firstName
                this.portalUser.lastName = this.lastName
                userService.userUpdateSelf(this.$http, this.firstName, this.lastName).then(response => {
                    store.dispatch('auth/authenticated').then(() => {
                        this.$router.push('user-profile')
                    })
                })
            }
        }
    }
}
</script>
